export const API_ENDPOINT = '/api';
export const WS_ENPOINT = '/ws';
export const XAPI_ENDPOINT = '/xapi';

export enum LOCAL_STORAGE_KEYS {
  CLASSROOM_USERNAME = 'classroom_username',
}

export const API_LIST_DEFAULT_PARAMS = {
  limit: 20,
  offset: 0,
};
